// extracted by css-extract-rspack-plugin
export default {"cls1":"BigCardDiscover-cls1_-nm","cls2":"BigCardDiscover-cls2_7Ow BigCardDiscover-cls1_-nm"};